import ApiUDS from "../../../gd/api/universal-data-selector"
import {ProjectAccess} from "../../../gd/const/project"
import {MissingUsersManagerInterface} from "../../components/add-missing-users/missing-users-manager-interface"

export type ModalMoveTo_MissingUsers = {
    projectIds      : ID[]
    workspaceIds    : ID[]
}

// const debug = "Modal_getMissingUsers"
const debug = false

export default async function Modal_getMissingUsers(manager: MissingUsersManagerInterface): Promise<ModalMoveTo_MissingUsers>{

    let addUsersToTargetWorkspace = true
    let addUsersToTargetProject = manager.showProjectAccess

    let response
    let movedItemsUsersIds: any[] = []

    debug && console.log(debug, 'process start', addUsersToTargetWorkspace, addUsersToTargetProject, manager.targetProject, manager.affectedTasksIds, manager.affectedProjectIds)

    // collect task users
    if (!_.isEmpty(manager.affectedTasksIds)) {
        const response = await ApiUDS.getTasksProjectsUsersRecursively(manager.affectedTasksIds).promise()
        _.map(response, (taskUser: any) => {
            movedItemsUsersIds.push(taskUser.userId)
        })

        movedItemsUsersIds = _.uniq(movedItemsUsersIds)
    }

    // collect project users
    if (!_.isEmpty(manager.affectedProjectIds)) {
        response = await ApiUDS.getProjectsUsersRecursively(manager.affectedProjectIds).promise()

        _.map(response, (projectUser: any) => {

            // we DO NOT copy customers ???
            if (projectUser.access === ProjectAccess.CLIENT) {
                return
            }

            movedItemsUsersIds.push(projectUser.userId)
        })

        movedItemsUsersIds =  _.uniq(movedItemsUsersIds)
    }

    // collect target project users ids
    const selectedProjectUsersIds: ID[] = manager.targetProject ? gd.session.projectUsers.filterByProject(manager.targetProject.id, ProjectAccess.LIMITED).map((pu: any) => pu.user.id) : []
    addUsersToTargetProject = addUsersToTargetProject && !_.isEmpty(selectedProjectUsersIds)

    // collect target workspace (project) users ids if any (no users for 'Projects' space)
    let selectedWorkspaceUsersIds: ID[] = []
    if (manager.targetProject?.workspace) {
        const workspaceProjectId = manager.targetProject.workspace.project.id
        selectedWorkspaceUsersIds= gd.session.projectUsers.filterByProject(workspaceProjectId, ProjectAccess.LIMITED).map((pu: any) => pu.user.id)
    }
    addUsersToTargetWorkspace = addUsersToTargetWorkspace && !_.isEmpty(selectedWorkspaceUsersIds)

    debug && console.log(debug, 'process users', addUsersToTargetProject, addUsersToTargetWorkspace, movedItemsUsersIds, selectedProjectUsersIds, selectedWorkspaceUsersIds)

    // find missing users in target project and workspace (project)
    let usersMissingInSelectedProject: ID[] = []
    let usersMissingInSelectedWorkspace: ID[] = []
    _.map(movedItemsUsersIds, (userId: ID) => {
        if(addUsersToTargetProject && !selectedProjectUsersIds.includes(userId)) {
            usersMissingInSelectedProject.push(userId)
        }

        if(addUsersToTargetWorkspace && !selectedWorkspaceUsersIds.includes(userId)) {
            usersMissingInSelectedWorkspace.push(userId)
        }
    })

    usersMissingInSelectedProject   = _.uniq(usersMissingInSelectedProject)
    usersMissingInSelectedWorkspace = _.uniq(usersMissingInSelectedWorkspace)

    debug && console.log(debug, 'process missing users', {
        projectIds      : usersMissingInSelectedProject,
        workspaceIds    : usersMissingInSelectedWorkspace,
    })

    return {
        projectIds      : usersMissingInSelectedProject,
        workspaceIds    : usersMissingInSelectedWorkspace,
    }
}